module.exports = __webpack_public_path__ + "img/help_dataset_overview_small.ed8a281f.png";